import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { LookupData } from '../models/lookup';

@Injectable({
  providedIn: 'root'
})
export class IncidenciasService {

  myAppUrl: string;

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getIncidencias(estado: string) {
    return this._http.get(this.myAppUrl + 'api/Incidencia/' + estado);
  }

  getIncidencia(id: number) {
    return this._http.get(this.myAppUrl + 'api/Incidencia/' + id + '/mono');
  }

  createIncidencia(incidencia: any) {
    return this._http.post(this.myAppUrl + 'api/Incidencia/', incidencia);
  }

  updateIncidencia(id: number, incidencia: any): Observable<any> {
    return this._http.put(this.myAppUrl + 'api/Incidencia/' + id, incidencia);
  }

  closeIncidencia(tasacionId: number, incidencia: any): Observable<any> {
    return this._http.put(this.myAppUrl + 'api/Incidencia/CierreIncidencia/' + tasacionId, incidencia);
  }

  getTasacionID(ID) {
    return this._http.get(this.myAppUrl + 'api/Tasaciones/Summary/' + ID);
  }

  getTieneIncidencia(id: number) {
    return this._http.get(this.myAppUrl + 'api/incidencia/tieneincidencia/' + id);
  }

  getIncidenciaByPs(idps: number) {
    return this._http.get(this.myAppUrl + 'api/incidencia/PS/' + idps);
  }
}


